import { lazy } from "react";

export const checkoutRoute = {
  path: "/checkout",
  exact: true,
  component: lazy(() => import("./index")),
};
